module.exports = __webpack_public_path__ + "static/media/twitter-icon.a93b4484.svg";